import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useStorageGate } from '../hooks/useStorageGate';

interface Props {
  className?: string;
  compact?: boolean;
}

const StorageRequiredBanner: React.FC<Props> = ({ className = '', compact = false }) => {
  const { t } = useTranslation();
  const { needsExternalDrive } = useStorageGate();

  return (
    <div
      className={`rounded-lg border p-4 ${compact ? 'text-sm' : ''} ${className}`}
      style={{ backgroundColor: 'var(--info-blue-bg)', borderColor: 'var(--info-blue-border)' }}
      data-testid="storage-required-banner"
      role="status"
    >
      <div className="flex items-start gap-3">
        <ExclamationTriangleIcon
          className="w-5 h-5 flex-shrink-0 mt-0.5"
          style={{ color: 'var(--info-blue-text)' }}
        />
        <div className="flex-1 min-w-0">
          <p className="font-medium" style={{ color: 'var(--info-blue-text)' }}>
            {t('storage.banner.title')}
          </p>
          <p className={`mt-1 ${compact ? 'text-xs' : 'text-sm'}`} style={{ color: 'var(--info-blue-text)' }}>
            {needsExternalDrive ? t('storage.banner.byodMessage') : t('storage.banner.message')}
          </p>
          <div className="mt-3 flex flex-col sm:flex-row gap-2">
            <Link
              to="/auth/storage"
              className="btn-primary inline-flex items-center justify-center px-4 py-2 text-sm font-semibold rounded-lg"
              data-testid="storage-banner-connect"
            >
              {t('storage.banner.connect')}
            </Link>
            {!needsExternalDrive && (
            <Link
              to="/upgrade"
              className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold rounded-lg border transition-colors"
              style={{
                borderColor: 'var(--info-blue-border)',
                color: 'var(--info-blue-text)',
                backgroundColor: 'var(--color-surface)',
              }}
              data-testid="storage-banner-upgrade"
            >
              {t('storage.banner.upgrade')}
            </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorageRequiredBanner;
